import { getQuestionKindCapabilities } from './shared-question-model-capabilities.consts';
import {
  QUESTION_KINDS,
  QUESTION_KIND_VALUES,
} from './shared-question-model-kind.consts';
import {
  isPageUrl,
  isUrlQuestionText,
} from './shared-question-model-url.consts';

export interface ScreenRecordingQuestionInput {
  readonly kind: string;
  readonly contentUrl?: string | null;
  readonly text?: string | null;
}

function ownsContentUrl(kind: string): boolean {
  const questionKind = QUESTION_KIND_VALUES.find((value) => value === kind);

  return (
    questionKind !== undefined &&
    getQuestionKindCapabilities(questionKind).ownsContentUrl
  );
}

export function hasUrlOrTaskQuestion(
  questions: readonly ScreenRecordingQuestionInput[]
): boolean {
  return questions.some(
    (question) =>
      question.kind === QUESTION_KINDS.MobileApp ||
      ownsContentUrl(question.kind) ||
      isPageUrl(question.contentUrl) ||
      isUrlQuestionText(question.text)
  );
}
